import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-navy text-white mt-16">
      <div className="container-ax py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-3">
            <Logo size={36} variant="light" />
            <div className="font-display font-bold text-lg">Recruvo Group</div>
          </div>
          <p className="text-sm text-slate-300 max-w-xs">Connecting great people with great companies through technology, expertise, and personal relationships.</p>
        </div>

        <div>
          <div className="eyebrow text-gold mb-3">For Job Seekers</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/jobs" className="hover:text-gold">Search jobs</Link></li>
            <li><Link to="/register" className="hover:text-gold">Create profile</Link></li>
            <li><Link to="/about" className="hover:text-gold">About Recruvo</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-gold mb-3">For Employers</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/register" className="hover:text-gold">Hire talent</Link></li>
            <li><a href="/#contact" className="hover:text-gold">Schedule consultation</a></li>
            <li><a href="/#industries" className="hover:text-gold">Industries we serve</a></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-gold mb-3">Company</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/about" className="hover:text-gold">About</Link></li>
            <li><a href="/#faq" className="hover:text-gold">FAQ</a></li>
            <li><a href="/#contact" className="hover:text-gold">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-ax py-6 flex flex-col md:flex-row items-center justify-between text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Recruvo Group. All rights reserved.</div>
          <div className="flex gap-5 mt-2 md:mt-0">
            <a href="#" className="hover:text-gold">Privacy</a>
            <a href="#" className="hover:text-gold">Terms</a>
            <a href="#" className="hover:text-gold">California Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
